import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { bindMenu } from 'material-ui-popup-state/hooks';
import HoverMenu from 'material-ui-popup-state/HoverMenu';
import { useOverflow } from '../OverflowProvider.js';
import CascadingProvider from './CascadingProvider.js';

const _Menu = styled(HoverMenu, { shouldForwardProp: prop => prop !== 'dense' }) `
  ${({ theme, dense, children }) => `
    margin: ${theme.spacing(1, 0, 0, 0)};
    .MuiMenu-list {
      padding: ${theme.spacing(dense ? 1 : 2, 0)};
    }
    ${!children && `display: none`};
  `}
`;
const CascadingMenu = (_a) => {
    var { children, popupState } = _a, rest = __rest(_a, ["children", "popupState"]);
    const { dense } = useOverflow();
    return (jsx(CascadingProvider, Object.assign({ parentPopupState: popupState }, { children: jsx(_Menu, Object.assign({}, bindMenu(popupState), { dense: dense }, rest, { children: children })) })));
};

export { CascadingMenu as default };
//# sourceMappingURL=CascadingMenu.js.map
